export enum UploadStatus {
  New,
  Preloaded,
  Sent,
  Failed,
}
